var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEmpresa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-35",
    width: 50,
    height: 39,
    viewBox: "0 0 50 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4992 2H37.5808L22.0816 24.9729H1L16.4992 2Z",
    className: "ccompli1",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4224 27.102L11.4192 36H33.5008L49 13.0271H32.7024L23.2064 27.102H17.4224Z",
    className: "ccustom",
    fill: "#312ECB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmpresa);
export default __webpack_public_path__ + "static/media/logo_empresa.3f4c9508ad22666e1bc65c5931f68ffc.svg";
export { ForwardRef as ReactComponent };